import React from 'react';
import { Container } from './styles';

// import smileImage from '~/assets/tv/november-2025/1.jpg';
import smileImage from '~/assets/tv/october-2025/TV1.png'; // TODO: placeholder, trocar pela imagem de novembro

interface IChangeYourSmile1Props {
  show: boolean;
  startAnim: boolean;
}

const ChangeYourSmile1: React.FC<IChangeYourSmile1Props> = ({
  show,
  startAnim,
}) => {
  return (
    <Container show={show} startAnim={startAnim}>
      <img className="bg" src={smileImage} alt="chega de esconder o Sorriso" />
    </Container>
  );
};

export default ChangeYourSmile1;
